<template>
  <v-dialog v-model="showDialog" max-width="750px">
    <v-card>
      <v-card-title>
        <h3>{{ $vuetify.t('$vuetify.AdminUsers.bulkRemoveUserRole') }}</h3>
      </v-card-title>
      <v-card-text>
        <v-card class="mb-2">
          <v-card-title class="pb-0">
            <h4>{{ $vuetify.t('$vuetify.AdminUsers.selectedUsers') }}</h4>
          </v-card-title>
          <v-card-text>
            <span v-for="(user, index) in users">
              {{ user.first_name }} {{ user.last_name }} ({{ user.username }})
              <span v-if="(users.length - 1) !== index">, </span>
            </span>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title class="pb-0">
            <h4>{{ $vuetify.t('$vuetify.AdminUsers.selectUserRole') }}</h4>
          </v-card-title>
          <v-card-text>
            <v-layout row no-wrap>
              <v-flex xs12 sm6 class="mr-2">
                <v-select
                  v-model="selectedRole"
                  :items="roles"
                  :label="$vuetify.t('$vuetify.RoleEdit.userRole')"
                  hide-details
                  item-text="name"
                  item-value="id"
                  @change="checkIfUserHasRole"/>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select
                  v-model="selectedIdeaSpace"
                  :items="ideaSpaces"
                  :label="this.$vuetify.t('$vuetify.AdminUsers.formIdeaSpace')"
                  @change="checkIfUserHasRole"/>
              </v-flex>
            </v-layout>
            <v-layout v-if="isDirty" row no-wrap class="mt-4">
              <v-flex sm12>
                <v-icon style="display: table-cell;">info</v-icon>
                <p v-if="selectedUsers.length === 0" style="display:table-cell; vertical-align: middle;">
                  {{ $vuetify.t('$vuetify.AdminUsers.bulkRemoveUserRoleNoUsers') }}
                </p>
                <p v-if="selectedUsers.length > 0" style="display:table-cell; vertical-align: middle;">
                  {{ $vuetify.t('$vuetify.AdminUsers.bulkRemoveUserRoleCount', selectedUsers.length) }}
                </p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn :disabled="this.selectedRole === null" color="primary" @click="bulkRemoveRole">
          {{ $vuetify.t('$vuetify.AdminUsers.removeRole') }}
        </v-btn>
        <v-btn @click="closeDialog">
          {{ $vuetify.t('$vuetify.AdminUsers.formClose') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {getIdeaSpaces} from '../../utils/ideaSpaces'
import api from '../../api'
import {getUserRoles} from '../../utils/userRoles'

export default {
  name: 'UserRoleBulkRemoveDialog',
  props: {
    show: Boolean,
    users: Array
  },
  data () {
    return {
      roles: [],
      ideaSpaces: [],
      selectedRole: null,
      selectedIdeaSpace: null,
      selectedUsers: [],
      isDirty: false
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        this.$emit('handleClose', value)
      }
    }
  },
  beforeMount: async function () {
    this.roles = await getUserRoles()
    this.ideaSpaces = await getIdeaSpaces(this.$store.getters.selected_school, this.$vuetify.t)
  },
  methods: {
    closeDialog: function () {
      this.$emit('reloadUsers')
      this.showDialog = false
    },
    bulkRemoveRole: function () {
      let userIds = this.users.map(usr => usr.id)
      api.user.removeRoleBulk(this.$store.getters.selected_school, userIds, this.selectedRole, this.selectedIdeaSpace)
        .then(res => {
          if (res.status < 400) {
            // to-do: response error handling
            this.closeDialog()
          }
          this.closeDialog()
        })
    },
    checkIfUserHasRole: function () {
      this.isDirty = true
      let roleName = this.roles.find(role => role.id === this.selectedRole).name
      this.selectedUsers = this.users.filter(usr => {
        return usr.roles.find(role => {
          return role[0] === roleName && role[1] === this.selectedIdeaSpace
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
